module.exports = __webpack_public_path__ + "static/media/MZW_05.9d335d4d.jpg";